import { Box, TableCell, Typography } from "@mui/material";
import { FirewatchChip } from "./FirewatchChip";
import { AggregateScoresNode } from "../FirewatchPage";
import { ClampWithTooltip } from "~/components/ClampWithTooltip/ClampWithTooltip";
import { useFirewatchException } from "~/components/FirewatchRow/hooks/useFirewatchException";

export type VulnerabilityCellProps = {
  row: AggregateScoresNode;
  size?: string;
  maxWidth?: number;
};

export function VulnerabilityCell({
  row,
  size,
  maxWidth,
}: VulnerabilityCellProps) {
  const { tags } = row || {};
  const isDashboardCard = size === "small";
  const { hasException } = useFirewatchException({
    row,
  });

  return (
    <TableCell sx={{ maxWidth }}>
      <ClampWithTooltip>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 700,
            lineHeight: "16px",
            color: hasException ? "text.secondary" : "text.primary",
          }}
        >
          {row?.title || row?.nodeTitle}{" "}
          <Typography
            component="span"
            sx={{ fontSize: isDashboardCard ? 12 : 14, fontWeight: 400 }}
          >
            {row?.description}
          </Typography>
        </Typography>
      </ClampWithTooltip>
      {size !== "small" && (
        <Box
          display="flex"
          gap={1}
          alignItems="center"
          mt={hasException || (tags?.length || 0) > 0 ? 1 : 0}
          sx={{ overflowX: "scroll", scrollbarWidth: "none" }}
        >
          {(tags?.length || 0) > 0 && (
            <Box display="flex" gap={1}>
              {tags?.map((tag) => (
                <FirewatchChip
                  key={tag.key}
                  tag={tag}
                  inactive={hasException}
                />
              ))}
            </Box>
          )}
        </Box>
      )}
    </TableCell>
  );
}
